/**
 * Which screen a verification session starts on.
 *
 * Document verification captures the document BEFORE liveness, so an IDV
 * session must never go straight to the liveness page. The backend enforces
 * this too (it refuses to create an AWS session until IDV reports the documents
 * staged); this is the frontend half of the same rule.
 */
export const VERIFICATION_TYPES = {
  AGE_ESTIMATION: 'age_estimation',
  IDV: 'idv',
};

export function isIdvSession(config) {
  return config?.type === VERIFICATION_TYPES.IDV;
}

/**
 * Route for the given session config. Anything that is not explicitly IDV —
 * including a missing or unreadable config — keeps the existing age-estimation
 * behaviour unchanged.
 */
export function verificationRouteFor(config, sessionId) {
  return isIdvSession(config) ? `/document/${sessionId}` : `/process/${sessionId}`;
}
